module.exports = __webpack_public_path__ + "img/en.3c929a75.svg";